import { render, staticRenderFns } from "./TourGuideLineal.vue?vue&type=template&id=2b804562"
import script from "./TourGuideLineal.vue?vue&type=script&lang=js"
export * from "./TourGuideLineal.vue?vue&type=script&lang=js"
import style0 from "./TourGuideLineal.vue?vue&type=style&index=0&id=2b804562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports